var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingMixingCircuit = function SvgDHeatingMixingCircuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 390,
    width: 40,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 399,
    width: 40,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 392.01,
    width: 40,
    height: 0.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 395.01,
    width: 6,
    height: 2,
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.89,397.01h-9.33v-2h9.33v2ZM602.44,397.01h-9.33v-2h9.33v2Z",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 395.01,
    width: 6,
    height: 2,
    fill: "#df1400"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 632.99,
    y: 382,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.94,
    y: 395,
    width: 10.01,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "630.85 382.51 645.13 382.5 638 394.99 630.85 382.51",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.27,383l-6.27,10.98-6.29-10.98h12.56M645.99,382h-16s8.02,14,8.02,14l7.99-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "624.5 388.88 637 396 624.51 403.15 624.5 388.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,389.74l10.99,6.27-10.98,6.29v-12.55M624,388.01v16s14-8.01,14-8.01l-14-7.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "630.85 409.5 638 397.01 645.14 409.5 630.85 409.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,398.01l6.27,10.99h-12.56l6.29-10.99M638,396l-8.02,14h16.01l-8-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 659,
    cy: 396,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,386c5.52,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M659,385c-6.08,0-11,4.92-11,11s4.93,11,11,11,11-4.92,11-11-4.93-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M661.92,392.65v5.69h-.98v-1.88s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.88h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 638,
    cy: 350,
    r: 14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,337c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M638,336c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M638.5,336.71c0,.13-.05.26-.15.36l-13.5,13.15c-.2.19-.51.19-.71,0-.19-.2-.19-.52,0-.71l13.5-13.15c.2-.19.51-.19.71,0,.09.1.14.22.14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652,349.86c0,.13-.05.25-.14.35-.19.2-.51.2-.71,0l-13.5-13.15c-.2-.19-.2-.51,0-.71.19-.2.51-.2.71,0l13.5,13.15c.1.1.15.23.15.36Z"
  })))));
};
export default SvgDHeatingMixingCircuit;